// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.fees.multifamily.RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { DeleteMultifamilyListingFeesRequestDto } from '../..';

export const RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/fees/multifamily/delete';

/**
 * Deletes a group of fees for a multi family listing
 */
export const RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete = (
  postData: DeleteMultifamilyListingFeesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, DeleteMultifamilyListingFeesRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyMultifamilyCostAndFeesV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
